/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Business_CategoryInputs */

const en_label_business_category = /** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Category`)
};

const es_label_business_category = /** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría del Negocio`)
};

const fr_label_business_category = /** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie de l'entreprise`)
};

const de_label_business_category = /** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmenskategorie`)
};

const id_label_business_category = /** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori Bisnis`)
};

/** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */
const ja_label_business_category = en_label_business_category;

/** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */
const zh_label_business_category = en_label_business_category;

/** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */
const ar_label_business_category = en_label_business_category;

/** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */
const it_label_business_category = en_label_business_category;

/** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */
const ru_label_business_category = en_label_business_category;

/** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */
const pt_label_business_category = en_label_business_category;

/** @type {(inputs: Label_Business_CategoryInputs) => LocalizedString} */
const ko_label_business_category = en_label_business_category;

/**
* | output |
* | --- |
* | "Business Category" |
*
* @param {Label_Business_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_business_category = /** @type {((inputs?: Label_Business_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Business_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_business_category(inputs)
	if (locale === "es") return es_label_business_category(inputs)
	if (locale === "fr") return fr_label_business_category(inputs)
	if (locale === "de") return de_label_business_category(inputs)
	if (locale === "ja") return ja_label_business_category(inputs)
	if (locale === "zh") return zh_label_business_category(inputs)
	if (locale === "ar") return ar_label_business_category(inputs)
	if (locale === "id") return id_label_business_category(inputs)
	if (locale === "it") return it_label_business_category(inputs)
	if (locale === "ru") return ru_label_business_category(inputs)
	if (locale === "pt") return pt_label_business_category(inputs)
	return ko_label_business_category(inputs)
});